export default __webpack_public_path__ + "static/media/ecmwf.5ac50697.svg";